import { ConfigProvider } from "../utils/local-antd";
import { useTheme } from "styled-components";
import en from "antd/locale/en_US";
import ar from "antd/locale/ar_EG";
import tr from "antd/locale/tr_TR";

import i18n from "../i18n";
import dayjs from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/ar";
import "dayjs/locale/tr";
import { AppLangs } from "../model/shared/enum/AppLangs.enum";

dayjs.locale(i18n.language);

const antdLocales = {
  [AppLangs.EN]: en,
  [AppLangs.AR]: ar,
  [AppLangs.TR]: tr,
};

type AntdConfigProps = {
  children: React.ReactNode;
};

export const AntdConfig: React.FC<AntdConfigProps> = ({ children }) => {
  const theme = useTheme();
  const currentLanguage = i18n.language;

  return (
    <ConfigProvider
      direction={currentLanguage === AppLangs.AR ? "rtl" : "ltr"}
      locale={antdLocales[currentLanguage as AppLangs]}
      theme={{
        token: {
          fontFamily: "'Roboto', 'Zain', sans-serif",
          colorPrimary: theme.main,
        },
        components: {
          Menu: {
            darkItemSelectedBg: theme.darkMain,
            darkItemSelectedColor: `${theme.sub} !important`,
            darkItemHoverBg: theme.lightMain,
          },
          Tabs: {
            inkBarColor: theme.black,
            itemActiveColor: `${theme.black} !important`,
            fontWeightStrong: 700,
            itemHoverColor: `${theme.success} !important`,
            itemColor: `${theme.danger} !important`,
            itemSelectedColor: `${theme.main} !important`,
          },
          Steps: {
            navArrowColor: theme.main,
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};
